import React, { useContext } from 'react';
import Row from '@amzn/meridian/row';
import Button from '@amzn/meridian/button';
import Icon from '@amzn/meridian/icon';
import Box from '@amzn/meridian/box';
import UserBadge from '../../DashboardComponents/UserBadge';
import { ModalContext } from './ModalContext';

import menuMeatballTokens from '@amzn/meridian-tokens/base/icon/menu-meatball';
import { renderUrl, urls } from '../../../../config/Url';
import { CoachingStatsAssociateDetailsOutputExtended } from '../../../../Types/CoachingStats';

interface UserBadgeRowProps {
  profiles: CoachingStatsAssociateDetailsOutputExtended[];
  maxCount: number;
  modalTitle: string;
}

const UserBadgeRow = ({
  profiles,
  maxCount,
  modalTitle,
}: UserBadgeRowProps) => {
  const { openProfilesModal } = useContext(ModalContext);

  const shouldShowMoreButton = profiles.length > maxCount;
  const profilesToDisplay = profiles.slice(
    0,
    maxCount - (shouldShowMoreButton ? 1 : 0)
  );

  return (
    <Row alignmentVertical='center' wrap='down'>
      {profilesToDisplay.map(profile => (
        <Box
          height='36px'
          width='30px'
          spacingInset='none'
          key={profile.userId}
        >
          <UserBadge
            username={profile.extendedUserInfo.alias}
            tooltip
            link={
              profile?.extendedUserInfo?.userID
                ? renderUrl(
                    `${urls.coachingNotes}/${profile.extendedUserInfo.userID}`
                  )
                : undefined
            }
          />
        </Box>
      ))}
      {shouldShowMoreButton && (
        <>
          <Button
            data-csa-c-type='button'
            data-csa-c-slot-id='dashboard-coaches-profile-button-slot'
            data-csa-c-content-id='dashboard-coaches-profile-more-button'
            type='secondary'
            onClick={() =>
              openProfilesModal({
                profiles: profiles.map(
                  profile => profile.extendedUserInfo.userName
                ),
                title: modalTitle,
              })
            }
            size='small'
          >
            <Icon tokens={menuMeatballTokens} />
          </Button>
        </>
      )}
    </Row>
  );
};

export default UserBadgeRow;
